import i18n, { i18nNS } from '../../i18n';
import request from '../request';
import { CoursesAPI } from './api-types';
import urls from './urls';

export async function getValidCourses(): Promise<CoursesAPI.GetValidCoursesSuccessBaseRespose> {
  const { data } = await request.get<CoursesAPI.GetValidCoursesResponse>(urls.getValidCourses);

  const { message } = data;
  if (message !== 'success') throw new Error(i18n.t('unable_to_fetch_courses', { ns: i18nNS.COURSE }));

  const { courses } = data;
  return { courses };
}
